// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1e0223a4] .otherDiv{width:100%}[data-v-1e0223a4] .otherDiv>span{flex:auto}.chart[data-v-1e0223a4],[data-v-1e0223a4] .otherDiv span:nth-child(2){flex:0 0 50%;margin-left:5px}.chart[data-v-1e0223a4]{height:500px}.chart.active[data-v-1e0223a4]{margin:0 auto;flex:0 0 50%;height:500px}.google-visualization-tooltip[data-v-1e0223a4]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
